import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';

import {
  Grid,
  Paper,
  Typography,
  CircularProgress,
} from '@material-ui/core';


import * as routes from '../../config/routes';
import Layout from '../../main/components/Layout';
import Alert from '../../common/components/Alert';
// import FormErrorDialog from '../../common/components/formErrorDialog';
import * as authActions from '../actions';
import LoginForm from '../components/LoginForm';
import classes from '../../css/getCSS';
import back01 from '../../assets/backs/back03.jpg';


class Login extends Component {
  componentDidMount() {
    document.title = 'Login';
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  inputChangedHandler = (event, field) => {
    this.props.inputChangedHandler(
      event,
      field,
      'loginForm',
      this.props.inputs,
    );
  }

  submitHandler = (event) => {
    this.props.doEmailLoginHandler(
      event,
      'loginForm',
      this.props.inputs,
    );
  }

  render() {
    let displayForm = (
      <form method="post" onSubmit={this.submitHandler}>
        <LoginForm
          inputs={this.props.inputs}
          inputChangedHandler={this.inputChangedHandler}
        />
      </form>
    );

    if (this.props.loading) {
      displayForm = (
        <div align="center">
          <CircularProgress align="center" size={50} />
        </div>
      );
    }

    let nonFieldErrors = null;
    if (this.props.errors) {
      nonFieldErrors = this.props.errors.map((error) => {
        return (
          <Alert key={error} type="danger">{error}</Alert>
        );
      });
    }

    const loginCaption = (
      <div className={classes.loginCaption}>
        <b>Attention old account holders:</b>
        <ul style={{ paddingBottom: '0px' }}>
          <li>Please login with your email/phone and password.</li>
          <li>You will be asked to connect your social account.</li>
          <li>
            {"You have to use your social account to login everytime, you won't be able to login using email and password."}
          </li>
        </ul>
        <br />
      </div>
    );

    return (
      <Layout hideNavbar rootClass={[classes.loginBack, classes.loginPageBack].join(' ')} background={back01}>
        <Grid container>
          <Grid container item md={8} xs={12} sm={7} className={classes.loginCaptionWrapper}>
            <Grid item md={9} sm={9} xs={12}>
              {loginCaption}
            </Grid>
          </Grid>
          <Grid item md={4} xs={12} sm={5} className={[classes.noPaddingXS].join(' ')}>
            <Paper className={[classes.card].join(' ')}>
              <Typography variant="title" style={{ color: '#666' }}>Login via Email or Phone</Typography>
              <br />
              <Typography variant="body1" style={{ color: '#666' }}>NOTE: After connecting your <b>social account</b> you cannot login via <b>email and password</b>.<br />Login via email and password is only for activating your account on new website for the first time.</Typography>
              <br />
              {nonFieldErrors}
              <br />
              {displayForm}
              <br />
              <Typography variant="body1"><Link to={routes.PASSWORD_RESET}>Forgot Password?</Link></Typography>
            </Paper>
          </Grid>
        </Grid>
        {/* <FormErrorDialog open={this.props.hasError} handleClose={this.props.toggleError} /> */}
      </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    inputs: state.auth.loginForm,
    hasError: state.auth.hasError,
    errors: state.auth.errors,
    loading: state.auth.loading,
    site: state.common.site,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleError: () => dispatch(authActions.toggleError()),
    inputChangedHandler: (event, field, form, inputs) => dispatch(
      authActions.inputChangedHandler(event, field, form, inputs),
    ),
    doEmailLoginHandler: (event, form, inputs) => dispatch(
      authActions.doEmailLoginHandler(event, form, inputs),
    ),
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/auth/containers/Login.js